import { type RawParagraphData, type StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import { Richtext } from 'storyblok-js-client';

export type ParagraphType = {
    component: 'paragraph';
    id: string;
    sbEditable?: StoryblokEditable;
    text: Richtext;
};

type TransformParagraphProps = {
    paragraph: RawParagraphData | RawParagraphData[] | undefined;
};

const transformParagraph = ({ paragraph }: TransformParagraphProps): ParagraphType | undefined => {
    if (!paragraph || (Array.isArray(paragraph) && !paragraph?.[0])) {
        return;
    }

    const paragraphData = Array.isArray(paragraph) ? paragraph[0] : paragraph;
    const { _uid, _editable, component, richText } = paragraphData;

    return {
        component,
        id: _uid,
        sbEditable: transformPreviewEditable(_editable),
        text: richText,
    };
};

export default transformParagraph;
